import Chartist from 'chartist';
import 'chartist-plugin-axistitle';

window.Chartist = Chartist;